import { render, staticRenderFns } from "./AthletesBreakdownReport.vue?vue&type=template&id=896b767c"
import script from "./AthletesBreakdownReport.vue?vue&type=script&lang=js"
export * from "./AthletesBreakdownReport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports